export const emojiMappings = {
    " ": ["   "],
    "#": [" #️⃣"],
    "?": ["❓"],
    "!": ["❗"],
    "0": ["0️⃣"],
    "1": ["1️⃣"],
    "2": ["2️⃣"],
    "3": ["3️⃣"],
    "4": ["4️⃣"],
    "5": ["5️⃣"],
    "6": ["6️⃣"],
    "7": ["7️⃣"],
    "8": ["8️⃣"],
    "9": ["9️⃣"],
    a: ["🅰️"],
    b: ["🅱️"],
    c: ["🅲"],
    d: ["🅳"],
    e: ["📧", "🅴", "🅔", "Ⓔ"],
    f: ["🅵"],
    g: ["🍥", "🅶", "🅖", "𝐆"],
    h: ["🅷", "🅗"],
    i: ["ℹ️"],
    j: ["🌶", "🅙", "𝐉"],
    k: ["🅚", "🅺"],
    l: ["👍", "💪"],
    m: ["Ⓜ️"],
    n: ["🅽", "🅝", "🄽"],
    ñ: ["ň"],
    o: ["🅾️", "⭕️", "⏺"],
    p: ["🅿️", "🇵"],
    q: ["🇶"],
    r: ["®️"],
    s: ["💲"],
    t: ["⬆️", "✝️"],
    u: ["🌙"],
    v: ["🔽", "✅"],
    w: ["🇼"],
    x: ["✖️", "❎", "❌", "🛠", "⚒", "⚔️", "✂️", "🤞🏻", "🙅🏼‍♂️", "🙅🏻‍♀️"],
    y: ["🤸", "🔧", "🔱"],
    z: ["🇿", "💤"]
};